import type { MarketQualityLevelValue } from "~/types/event";
import type { IRowChangeDisplay } from "~/utils/getRowChangeDisplay";

export enum EmptySide {
  NO_BIDS = "no-bids",
  NO_ASKS = "no-asks",
  NO_ORDERS = "no-orders",
}

export enum QualityDot {
  FILLED = "filled",
  OUTLINE = "outline",
}

export enum SpreadBand {
  TIGHT = "tight",
  MODERATE = "moderate",
  WIDE = "wide",
  VERY_WIDE = "very-wide",
}

export interface ISpreadRange {
  min: number;
  max: number;
}

export interface IMarketQualityHover {
  title: string;
  text: string;
}

export interface IQualityMark {
  dot: QualityDot;
  hover: IMarketQualityHover;
}

export interface ISpreadCell {
  value: string;
  caption: IRowChangeDisplay | null;
}

export interface IMarketQuality {
  level: MarketQualityLevelValue | null;
  mark: IQualityMark | null;
  hidesChance: boolean;
  showsOwnBook: boolean;
  greysPrices: boolean;
}
